import { FC } from 'react';
import HostTable from './Tables/HostTable';
import LocationsTable from './Tables/LocationsTable';
import PickupDetailsTable from './Tables/PickupDetailsTable';
import OnewayTable from './Tables/OnewayTable';
import SeasonPriceTable from './Tables/SeasonPriceTable';
import SubPriceTable from './Tables/SubPriceTable';
import HostModal from './Modals/AddHost';
import LocationModal from './Modals/AddLocation';
import PickupDetailsModal from './Modals/AddPickupDetails';
import OnewayModal from './Modals/AddOneway';
import SeasonPriceModal from './Modals/SeasonPriceModal';
import SubPriceModal from './Modals/SubPrice';

interface IProps {
  tab: number;
  search: string;
  isDeleteArray: boolean;
  arrayForDelete: number[];
  setArrayForDelete: (sps: number[]) => void;
  open: boolean[];
  handleClose: () => void;
}

const AdminContent: FC<IProps> = ({
  tab,
  search,
  isDeleteArray,
  arrayForDelete,
  setArrayForDelete,
  open,
  handleClose
}) => {
  let table;
  let modal;

  switch (tab) {
    case 0:
      table = <HostTable />;
      modal = <HostModal handleClose={handleClose} open={open[0]} />;
      break;
    case 1:
      table = <LocationsTable />;
      modal = <LocationModal handleClose={handleClose} open={open[1]} />;
      break;
    case 2:
      table = (
        <PickupDetailsTable
          isDeletePD={isDeleteArray}
          PDforDelete={arrayForDelete}
          setPDforDelete={setArrayForDelete}
        />
      );
      modal = <PickupDetailsModal handleClose={handleClose} open={open[2]} />;
      break;
    case 3:
      table = <OnewayTable />;
      modal = <OnewayModal handleClose={handleClose} open={open[3]} />;
      break;
    case 4:
      table = (
        <SeasonPriceTable
          isDeleteSP={isDeleteArray}
          SPforDelete={arrayForDelete}
          setSPforDelete={setArrayForDelete}
        />
      );
      modal = <SeasonPriceModal handleClose={handleClose} open={open[4]} />;
      break;
    case 5:
      table = <SubPriceTable search={search} />;
      modal = <SubPriceModal handleClose={handleClose} open={open[5]} />;
      break;
  }

  return (
    <>
      {table}
      {modal}
    </>
  );
};
export default AdminContent;
